import { render } from "./ecologySection.vue?vue&type=template&id=5e8f5e10"
import script from "./ecologySection.vue?vue&type=script&lang=js"
export * from "./ecologySection.vue?vue&type=script&lang=js"

import "./ecologySection.vue?vue&type=style&index=0&id=5e8f5e10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__